module.exports = __webpack_public_path__ + "static/media/security.f07fc2fc.jpg";